<div class="categories_tab">
  <p class="link">
    {{
      'PLACEHOLDERS.CATEGORIES' | translate: currentTranslationLanguageTrigger
    }}
  </p>
  <div class="dropdown_menu_wrapper">
    <div class="left_wrapper">
      <p>{{ 'PAGES.HOME.CATEGORIES.HELP_TITLE' | translate }}</p>
      <span>{{ 'PAGES.HOME.CATEGORIES.TASK_SELECTION' | translate }}</span>

      <div class="as_to_wrap">
        <p class="as_to_text1">{{ 'PAGES.HOME.CATEGORIES.AS_TASK_OWNER' | translate }}</p>
        <p class="as_to_text2">{{ 'PAGES.HOME.CATEGORIES.NEED_HELP' | translate }}</p>
      </div>
    </div>
    <ul class="desktop_cat_wrapper">
      <li *ngFor="let link of verticalsLinks; let i = index">
        <a
          href="{{ environment.seoBaseHref }}{{ link[1] }}/{{
            environment.seo.service
          }}"
          >{{ link[0] }}</a
        >
      </li>
      <li>
        <a
          class="last_link"
          [href]="externalLinksService.getPageUrl('categories')"
          >{{ 'PAGES.HOME.CATEGORIES.SEE_ALL' | translate }}</a
        >
      </li>
    </ul>
  </div>
</div>

<mat-menu class="categories_menu" #menu="matMenu">
  <a
    *ngFor="let link of verticalsLinks; let i = index"
    mat-menu-item
    href="{{ environment.seoBaseHref }}{{ link[1] }}/{{
      environment.seo.service
    }}"
  >
    {{ link[0] }}
  </a>
  <a
    mat-menu-item
    class="see_more_cats"
    [href]="externalLinksService.getPageUrl('categories')"
    >Se flere...</a
  >
</mat-menu>
